import { MetadataElement } from "./SingleUploadModel";

interface ReadOnlyFieldProps {
    element: MetadataElement;
}

const ReadOnlyField: React.FC<ReadOnlyFieldProps> = ({ element }:ReadOnlyFieldProps) => {
  const {value}= element || {};
  if (!value || !value.display_value) {
    return <div>-</div>;
  }
  if (element.datatype === "DATE") {
    return <div>{new Date(element?.value?.display_value || "").toLocaleDateString()}</div>;
  }
  return (
    <div>
      <div style={{wordWrap:'break-word'}}>{value?.display_value}</div>
    </div>
  );
};

export default ReadOnlyField;